import React from "react";
import CountUp from "react-countup";
import { getDecimals } from "../../../utils/miscUtils";

const CustomReactCountup = ({
  start,
  end,
  decimals,
  useEasing,
  suffix,
  enableScrollSpy,
  scrollSpyOnce,
  className,
  redraw,
  duration,
  ...rest
}) => {
  return (
    <CountUp
      redraw={redraw ?? true}
      duration={duration ?? 0.5}
      className={className}
      start={start ?? 0}
      end={end ?? 0}
      decimals={getDecimals(end) ?? 1}
      useEasing={useEasing ?? false}
      suffix={suffix ?? ""}
      enableScrollSpy={enableScrollSpy ?? true}
      scrollSpyOnce={scrollSpyOnce ?? true}
      {...rest}
    />
  );
};

export default CustomReactCountup;
